export const ORDER_CUSTOMER_FIELD_MODES = {
    required: "required",
    optional: "optional",
    hidden: "hidden"
};

export const orderCustomerFieldModeLabels = {
    required: "Obligatorio",
    optional: "Opcional",
    hidden: "No pedir"
};

export const orderCustomerFieldModesOrder = [
    ORDER_CUSTOMER_FIELD_MODES.required,
    ORDER_CUSTOMER_FIELD_MODES.optional,
    ORDER_CUSTOMER_FIELD_MODES.hidden
];

export const defaultOrderCustomerFields = () => ({
    email: ORDER_CUSTOMER_FIELD_MODES.optional,
    identification: ORDER_CUSTOMER_FIELD_MODES.hidden
});

export const orderCustomerFieldsItems = [
    {
        key: "email",
        name: "Correo electrónico",
        description: "Si el cliente paga en línea, el correo se pide siempre."
    },
    {
        key: "identification",
        name: "Identificación",
        description: "Tipo y número de documento. Se piden juntos."
    }
];

export const mapOrderCustomerFieldsFromApi = (data = {}) => {
    const fields = (data && data.orderCustomerFields) || {};
    const defaults = defaultOrderCustomerFields();
    return {
        email: fields.email || defaults.email,
        identification: fields.identification || defaults.identification
    };
};

export const mapOrderCustomerFieldsToApi = (fields) => ({
    orderCustomerFields: {
        email: fields.email,
        identification: fields.identification
    }
});
